import { IMAGINARY_PIPE_CONFIG } from './imaginary-config.token';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { ImageService } from '@wizbii-utils/angular/core';

@Pipe({
  name: 'imaginarySrc',
  standalone: true,
})
export class ImaginarySrcPipe implements PipeTransform {
  readonly #imaginaryPipeConfig = inject(IMAGINARY_PIPE_CONFIG);

  readonly imageService = new ImageService(this.#imaginaryPipeConfig.imaginaryUrl);

  transform(imageUrl: string, ratio: number, width: number, height?: number): any {
    let imageSrcSet = '';

    if (ratio > 1) {
      for (let index = 1; index <= ratio; index++) {
        const imageSrc: string = this.imageService.resize(imageUrl, {
          width: width * index,
          height: height ? height * index : undefined,
        });

        imageSrcSet += index === ratio ? `${imageSrc} ${index}x` : `${imageSrc} ${index}x, `;
      }

      return imageSrcSet;
    }

    return this.imageService.resize(imageUrl, {
      width,
      height: height ? height : undefined,
    });
  }
}
